import { globalQueryKeys } from '../global-query-keys';

export const FILE_INFOS_API_URL = 'ui/partner/file_infos';

export const fileInfosQueryKeys = {
  global: [...globalQueryKeys.files],
  all: () => [...fileInfosQueryKeys.global, FILE_INFOS_API_URL],
  detail: (fileId: string) => [...fileInfosQueryKeys.all(), fileId],
};
